<template>
  <div>
    <div class="page-title">{{title}}</div>

    <div v-if="!isLoaded" class="loader"></div>

    <div class="prescription-list">
      <div v-for="(catalog, catalogKey) in list" :key="catalogKey">
        <div :class="'prescription-catalog' + (mute ? ' opacity-50' : '')">
          {{ catalog.catalog.name }}
        </div>

        <div>
          <PrescriptionItem
            v-for="(item, itemKey) in catalog.prescriptions"
            :key="itemKey"
            :prescription="item"
            :selectPrescription="selectPrescription" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PrescriptionItem from './Item'

  export default {
    name: 'Prescription',

    props: ['list', 'mute', 'title', 'selectPrescription'],

    components: { PrescriptionItem },

    data() {
      return {};
    },

    computed: {
      isLoaded() {
        return this.$store.state.prescriptionsLoaded;
      },
    },

    methods: {},
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .prescription-list {
    margin: 0 0 10px;

    .prescription-catalog {
      position: relative;
      padding: 10px 15px;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      color: $primary;
      background-color: $light-gray-bg;
      border-top: 2px solid $primary;
    }
  }
</style>
